module.exports = __webpack_public_path__ + "img/header-bg.ad80237e.svg";